import {DialogTitle} from '@apps-common/ui-components';
import {Group, GroupRemove} from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import {bool, func, object} from 'prop-types';
import React from 'react';
import {useDispatch} from 'react-redux';
import {notify} from '@actions/notifications';
import {trackEvent} from '@app/analytics';
import {useShareCollection} from '@app/api/collections';

const EVENT_NAME = 'Manage Sharing Modal';

const ShareCollectionModal = ({open, onClose, collection}) => {
  const dispatch = useDispatch();

  const {mutate: shareCollection, isPending: isUpdatingCollection} =
    useShareCollection({
      onSuccess: (_, {share}) => {
        trackEvent(EVENT_NAME, {
          action: `${share ? 'Shared' : 'Unshared'} collection`,
          collectionId: collection.id,
        });
        onClose();
      },
      onError: () => {
        dispatch(
          notify({
            message: 'There was an error while updating share status',
            severity: 'error',
          })
        );
      },
    });

  const isShared = collection.permissions.shared;

  const onToggleShare = () => {
    shareCollection({collectionId: collection.id, share: !isShared});
  };

  const handleOnClose = () => {
    trackEvent(EVENT_NAME, {
      action: 'closed modal',
    });

    onClose();
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleOnClose}>
      <DialogTitle
        onClose={handleOnClose}
        title={
          isShared
            ? 'Remove access for collection?'
            : 'Share collection with your organization?'
        }
      />
      <DialogContent>
        <Typography>
          {isShared
            ? 'This collection will no longer be accessible to anyone within your organization, besides you.'
            : 'Anyone within your organization will be able to view and access this collection.'}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOnClose} variant="outlined">
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={isUpdatingCollection}
          onClick={onToggleShare}
          startIcon={isShared ? <GroupRemove /> : <Group />}
        >
          {isUpdatingCollection
            ? !isShared
              ? 'Sharing...'
              : 'Removing Access...'
            : !isShared
              ? 'Share'
              : 'Remove Access'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ShareCollectionModal.propTypes = {
  onClose: func,
  collection: object,
  open: bool,
};

export default ShareCollectionModal;
